import { render, staticRenderFns } from "./switchSvg.vue?vue&type=template&id=f3dee508&"
import script from "./switchSvg.vue?vue&type=script&lang=js&"
export * from "./switchSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports